// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import WithNativeAttributes from '../../internal/utils/with-native-attributes';
export default function TextareaMode({ textareaRef, controlId, textareaAttributes, nativeTextareaAttributes, }) {
    return (React.createElement(WithNativeAttributes, { ...textareaAttributes, tag: "textarea", componentName: "PromptInput", nativeAttributes: nativeTextareaAttributes, ref: textareaRef, id: controlId }));
}
//# sourceMappingURL=textarea-mode.js.map